import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { formatDateToDayOfMonth } from 'utils/dates';
import { interpolate } from 'utils/string/format';

import css from './Trial.module.css';

interface ITrial {
  mode: 'full' | 'short';
}

const Trial = ({ mode }: ITrial) => {
  const {
    app: { i18n, locale },
    savedFilters: { popup },
    filter,
    profile,
    view,
  } = useStore();

  const shouldHideTrial =
    !popup?.notificationsRate ||
    !popup.hasSubscriptionTrialAvailable ||
    !popup.smsParams ||
    profile.hasUnlimitedNotificationsLicense ||
    popup.hasFreeSubscription;

  if (shouldHideTrial) return null;

  const trialExpirationText = popup.trialEndDate
    ? interpolate(i18n.subscriptions.trial.exactDate, {
        date: formatDateToDayOfMonth(new Date(popup.trialEndDate), locale),
      })
    : interpolate(i18n.subscriptions.trial.freeDays, {
        days: filter.trialDaysDuration.toString() || '',
      });

  return (
    <div className={css.trial}>
      {!popup.isTrialSubscriptionActivated && <span className={css.special}>{i18n.subscriptions.trial.special}</span>}

      <p className={cn('glz-p glz-is-size-3', css.expiration)}>
        <strong>{trialExpirationText}</strong>{' '}
        <span>
          {interpolate(i18n.subscriptions.trial.priceAfter, { atis: view.atisCount(Number(popup?.notificationsRate)) })}
        </span>
      </p>

      {mode === 'full' && (
        <>
          <p className={cn('glz-p glz-is-size-3', css.text)}>{i18n.subscriptions.trial.saveTime}</p>
          <p className={cn('glz-p glz-is-size-3', css.text)}>{i18n.subscriptions.trial.freePersonalBoards}</p>
        </>
      )}
    </div>
  );
};

const connected = observer(Trial);

export { connected as Trial };
